import { Typography, Button, Input, Form, Layout, Card, message } from "antd";
import { useState } from "react";
import { postData } from "../../../utils";
import { useNavigate } from "react-router-dom";
import addDeleteGetLocalStorage from "../../../prototype/addDeleteGetLocalStorage";
import { STORAGE } from "../../../Common/LocalVariable";
const { Title } = Typography;

const Login = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Success and error message handlers
  const showMessage = (type, msg) => {
    messageApi.open({
      type,
      content: msg,
    });
  };

  const handleLogin = async (values) => {
    setIsLoading(true);

    // Prepare the data object to send in the POST request
    const loginData = {
      email: values.email,
      password: values.password,
    };

    try {
      // Call the postData function with the login endpoint and login data
      const response = await postData("/v1/admin/auth/login", loginData);

      // Handle successful login
      localStorage.setItem("token", response.data.token); // Store the token

      // Show success message; ensure the response has a message property
      showMessage("success", response.message || "Login successful");
      addDeleteGetLocalStorage(STORAGE?.USER_TOKEN, response, "add", "single");
      setTimeout(() => {
        navigate("/admin/doctors");
      }, 500);
    } catch (err) {
      // Handle error response
      console.error("Login failed:", err);
      showMessage("error", err.response?.data?.message || "Login failed"); // Show the error message, if available
    } finally {
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  return (
    <>
      {contextHolder} {/* This should be included for message API to work */}
      <Layout>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <Card className="relative" style={{ width: 400 }}>
            <img width={100} src="/images/LogoSquare.svg" alt="Logo" className="mx-auto absolute top-[-120px] left-0 right-0" />
            <Title level={3} align="center">
              Login to your account
            </Title>
            <Form
              name="login"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={handleLogin} // Using onFinish to handle form submission
              autoComplete="off"
            >
              <Form.Item
                label="Email Address"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Email Address!",
                  },
                ]}
              >
                <Input size="large" />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please enter your password!" }]}
              >
                <Input.Password size="large" />
              </Form.Item>
              <Button className="w-full mt-4" size="large" type="primary" htmlType="submit" loading={isLoading}>
                Login
              </Button>
            </Form>
          </Card>
        </div>
      </Layout>
    </>
  );
};

export default Login;
